import { render, staticRenderFns } from "./MobilePreventionEnvironmentRequestCreate.vue?vue&type=template&id=afb8ba8a&scoped=true&"
import script from "./MobilePreventionEnvironmentRequestCreate.vue?vue&type=script&lang=js&"
export * from "./MobilePreventionEnvironmentRequestCreate.vue?vue&type=script&lang=js&"
import style0 from "./MobilePreventionEnvironmentRequestCreate.vue?vue&type=style&index=0&id=afb8ba8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb8ba8a",
  null
  
)

export default component.exports